module.exports = __webpack_public_path__ + "img/programme6.ea7e9dc3.png";